<head>
  <!-- Google Tag Manager -->

  <script>(function (w, d, s, l, i) { w[l] = w[l] || []; w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' }); var f = d.getElementsByTagName(s)[0], j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f); })(window, document, 'script', 'dataLayer', 'GTM-KB72W5J');</script>

  <!-- End Google Tag Manager -->
</head>
<!-- Google Tag Manager (noscript) -->

<noscript>
  <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-KB72W5J" height="0" width="0" style="display:none;visibility:hidden"></iframe>
</noscript>

<!-- End Google Tag Manager (noscript) -->

<div class="templateCharts">

  <!-- <h1 style="text-align: center; background-color: white">
    Welcome to {{ title }}!
  </h1> -->

  <ul class="nav nav-pills mb-3 justify-content-center mobileTab" id="myTab" role="tablist" style="font-size: 2rem;">
    <li class="nav-item" role="presentation" class="navItems">
      <button class="nav-link active navText" id="feed-tab" data-bs-toggle="pill" data-bs-target="#feed" type="button"
        role="tab" aria-controls="feed" aria-selected="true" style="font-size: large"><i
          class="fa-solid fa-square-rss"></i> Feed</button>
    </li>
    <li class="nav-item" role="presentation" class="navItems">
      <button class="nav-link navText" id="stats-tab" data-bs-toggle="pill" data-bs-target="#stats" type="button"
        role="tab" aria-controls="stats" aria-selected="false" style="font-size: large"><i
          class="fa-solid fa-chart-simple"></i> Stats</button>
    </li>
    <li class="nav-item" role="presentation" class="navItems">
      <button class="nav-link navText" id="port-tab" data-bs-toggle="pill" data-bs-target="#port" type="button"
        role="tab" aria-controls="port" aria-selected="false" style="font-size: large"><i
          class="fa-solid fa-chart-pie"></i> Portfolio</button>
    </li>
  </ul>
  <div class="tab-content" id="myTabContent">
    <div class="tab-pane fade show active feedTab" id="feed" role="tabpanel" aria-labelledby="feed-tab">
      <div class="row" style="margin: auto">
        <div class="col">
          <div>
            <div style="text-align: center; width:auto">
              <div style="margin:auto;">
                <div id="elf" class="elfsight-app-1bd35861-fde3-4be5-9dfd-a51de5105af6"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <br />
    </div>

    <div class="tab-pane fade" id="stats" role="tabpanel" aria-labelledby="stats-tab">
   
          <!-- <div id="containerNewPerf" class="perfCon" style="text-align: center;"></div> -->
        <div #screen id="theGraph">
          <app-main-graph></app-main-graph>
        </div>
      
      <div class="row" style="margin: auto" #risk id="risk">
        <div class="col avgMarg">
          <div style="text-align: center; margin: auto;">
            <div style="margin:auto;">
              <section class="section" style="padding-bottom: 0rem; padding-top: 0rem" id="about">
                <div class="shell shell--size-3">
                  <div class="section__head">
                    <!-- <h6>Algorithm</h6> -->
        
                    <h2>Risk Score</h2>
                  </div><!-- /.section__head -->
                </div>
              </section>
              <div id="containerRisk" class="riskCon" style="text-align: center; margin: auto"></div>
            </div>
          </div>
          <p style="font-size: large; text-align: center">Average Risk Score: <b>{{riskText}} / 10</b> &nbsp;<a [routerLink]="['/information/risk']" id="RiskInformation" class="wow fadeInRight" data-wow-delay="0.5s"><i
            class="fa-solid fa-circle-info fa-1x howItWorksiRemainingMob"></i></a></p>
        </div>
      </div>
      <br />
      <div class="row" style="margin: auto" #copiers id="copiers">
        <div class="col copyMarg">
          <div style="text-align: center; margin: auto;">
            <div class="card-text" style="margin:auto;">
              <section class="section" style="padding-bottom: 0rem" id="about">
                <div class="shell shell--size-3">
                  <div class="section__head">
                    <!-- <h6>Algorithm</h6> -->
                    
                    <h2>Copiers History</h2>
                  </div><!-- /.section__head -->
                </div>
              </section>
              <div id="copiersContainer" class="copiersCon" style="text-align: center; margin:auto"></div>
            </div>
            <div style="font-size: large">We currently have <b>{{recentCopiers}}</b> traders copy
              trading us!</div>
            </div>
        </div>
      </div>
      <br />
    </div>

    <div class="tab-pane fade" id="port" role="tabpanel" aria-labelledby="port-tab">
      <section class="section" style="height: 70vh" id="performance" style="padding-bottom: 0px">
        <div class="shell shell--size-3" style="height: 100%">
          <app-main-portfolio></app-main-portfolio>
        </div>
      </section>
  </div>
  <br/>

</div>